import styled from '@emotion/styled';
import { ChevronIcon } from 'src/ui/assets/icons/arrow/ChevronIcon';
import { withConfig } from 'src/withConfig';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { Input } from 'src/domains/players/webview/components/form/input/Input';

export const PaymentMethodLabel = withConfig(theme => styled('div', { label: 'PaymentMethodLabel' })`
    font-weight: ${theme.star.fontWeight.xMedium};
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.43;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
`);

export const PaymentLogosContainer = styled('div', { label: 'PaymentLogosContainer' })`
    display: inline-flex;
    gap: 4px;
    margin-left: auto;
    align-items: center;
`;

export const PaymentMethodIcon = styled('div', { label: 'PaymentMethodIcon' })`
    width: 48px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
`;

export const PaymentMethodText = withConfig(theme => styled('span', { label: 'PaymentMethodText' })`
    flex: 1;
    text-align: left;
    font-weight: ${theme.star.fontWeight.medium};
    font-size: ${theme.star.fontSize.xRegular};
`);

export const ArrowIcon = withConfig(theme => styled(ChevronIcon, { label: 'ArrowIcon' })<{ isSignup: boolean }>`
    padding: 6px;
    color: ${({ isSignup }): string => (isSignup === true ? theme.star.signUp.txtColor : theme.star.multiDeposit.txtColorSecondary)};
`);

export const PaymentMethodSection = styled('div', { label: 'PaymentMethodSection' })`
    margin-top: 24px;
`;

export const PayButton = styled(Button, { label: 'PayButton' })`
    margin-top: 32px;
    text-transform: capitalize;
    width: 100%;
`;

export const PayButtonApplePay = withConfig(theme => styled(Button, { label: 'PayButtonApplePay' })`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px;
    width: 100%;
    background-color: ${theme.star.multiDeposit.bgApplePay};
    position: relative;
    transition: all 0.2s ease;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        opacity: 0;
        transition: opacity 0.2s ease;
        pointer-events: none;
        border-radius: inherit;
    }
    
    &:not(:disabled):hover::before {
        opacity: 0.2;
    }
`);

export const CashBalanceWrapper = withConfig(theme => styled('div', { label: 'CashBalanceWrapper' })`
    align-items: center;
    color: currentcolor;
    display: flex;
    gap: 2px;
    font-size: ${theme.star.fontSize.small};
    line-height: 1.25;
    margin-top: 8px;
    text-transform: capitalize;
`);


export const AmountLabel = withConfig(theme => styled('p', { label: 'AmountLabel' })`
    font-weight: ${theme.star.fontWeight.xMedium};
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.43;
    margin: 0;
`);

export const InputAmount = styled(Input, { label: 'InputAmount' })`
    margin-top: 8px;
`;
